import React from 'react';
import PropTypes from 'prop-types';
import { find, flatMap } from 'lodash';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import TeamFilter from '../navigation/team-filter';
import CategoryFilter from '../navigation/category-filter';

const openStyle = {
  transition: 'opacity 0.3s linear',
  opacity: 1,
  height: 'auto',
};

const closedStyle = {
  transition: 'opacity 0.3s linear',
  opacity: 0,
  height: 0,
};

const CalendarFilters = ({
  club,
  eventType,
  eventTypeFilters,
  isMobile,
  sections,
  openFilter,
  onChangeEventType,
  onChangeTeam,
  t,
  teamId,
}) => {
  const selectedTeam = teamId
    ? find(
        flatMap(sections, (section) => section.teams),
        { id: teamId },
      )
    : null;

  return (
    <>
      <div style={openFilter === 'team' ? openStyle : closedStyle}>
        <TeamFilter
          name="team"
          club={club}
          sections={sections}
          selected={teamId}
          label={selectedTeam && !isMobile ? selectedTeam.name : t('common:team_filter_label')}
          onChange={onChangeTeam}
        />
      </div>
      <div style={openFilter === 'category' ? openStyle : closedStyle}>
        <CategoryFilter
          name="category"
          selected={eventType}
          categories={eventTypeFilters}
          label={t('common:events_filter_label')}
          onChange={onChangeEventType}
          isShowingInPanel={isMobile}
        />
      </div>
    </>
  );
};

CalendarFilters.defaultProps = {
  eventType: null,
  openFilter: null,
  teamId: null,
};

CalendarFilters.propTypes = {
  eventType: PropTypes.oneOf(['fixtures', 'events', 'training']),
  eventTypeFilters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
  club: CLUB_PROP_TYPES.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onChangeEventType: PropTypes.func.isRequired,
  onChangeTeam: PropTypes.func.isRequired,
  openFilter: PropTypes.string,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      teams: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  teamId: PropTypes.number,
  t: PropTypes.func.isRequired,
};

export default CalendarFilters;
